var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"documents-filter-form"},[(_vm.category)?_c('field-box',{attrs:{"name":"category","type":"select","options":_vm.categoryOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }